import { FeatureFlag } from '../../../FeatureFlags';

type FetchAllEnabledFeatureFlagsResponse = {
  response: Response;
  json?: {
    allEnabledFlags: [
      {
        name: FeatureFlag;
      }
    ];
  };
  error?: string;
};

export async function fetchAllEnabledFeatureFlags(): Promise<
  FetchAllEnabledFeatureFlagsResponse
> {
  try {
    const response = await fetch('/api/proxy/v3/featureFlag/enabled', {
      method: 'GET',
      credentials: 'same-origin',
    });
    let error;
    let json;
    if (response.ok) {
      json = await response.json();
    } else {
      error = 'Could not fetch feature flags';
    }
    return { response, json, error };
  } catch (err) {
    throw new Error(err.message);
  }
}
